/**
 * Copyright © Veeam Software Group GmbH.
 */

import { UserRoleRepresentation } from '@veeam-vspc/models/web-controllers';
import { immediatelyValidateFlag, FormValidator } from '@veeam-vspc/shared/components';

import type { VspcLang } from 'configs/languages';

import type { CompanyUserModel } from 'views/pages/RolesAndUsersPage/components/CompanyUser/interfaces/company-user-model';

export const stepValidate = (lang: VspcLang, data: CompanyUserModel, isEdit: boolean) => {
    const validator = new FormValidator(data);

    if (data.userRole === UserRoleRepresentation.Subtenant) {
        validator.validate('description')
            .string()
            .maxLength(1000);
    }

    if (!isEdit && data.isVcdCompany && data.userRole === UserRoleRepresentation.Subtenant) {
        validator.validate('vcdUserId')
            .string()
            .required();
    } else if (isEdit) {
        if (data.password || data.confirmPassword) {
            validator.validate('password')
                .string()
                .required();

            validator.validate('confirmPassword')
                .string()
                .required()
                .check((value) => {
                    if (value !== validator.value.password) {
                        return lang.PASSWORDS_DO_NOT_MATCH;
                    }
                });

            data.selfEdit && validator.validate('oldPassword')
                .string()
                .required();
        }
    } else {
        validator.validate('login')
            .string()
            .maxLength(128)
            .required()
            .check((value) => {
                const result = RCOP.utils.Validator.vacUserName(value);

                if (typeof result === 'string') {
                    return `${result}${immediatelyValidateFlag}`;
                }
            });

        validator.validate('password')
            .string()
            .required();

        validator.validate('confirmPassword')
            .string()
            .required()
            .check((value) => {
                if (value !== validator.value.password) {
                    return lang.PASSWORDS_DO_NOT_MATCH;
                }
            });
    }

    return validator.result();
};
